import React, { useState } from 'react';
import { auth } from '../supabaseClient';

const LoginForm = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [isRegister, setIsRegister] = useState(false);
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      let result;
      if (isRegister) {
        result = await auth.signUp(email, password);
        if (result.data?.user) {
          setMessage('注册成功！请检查邮箱验证链接');
          setTimeout(() => setIsRegister(false), 2000);
        }
      } else {
        result = await auth.signIn(email, password);
        if (result.data?.user) {
          onLogin(result.data.user);
        }
      }

      if (result.error) {
        setMessage(result.error.message);
      }
    } catch (error) {
      setMessage('操作失败: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-dark-bg flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-black text-cyber-blue cyber-text mb-2">
            日常好物档案
          </h1>
          <p className="text-gray-400 text-sm">Cloud Edition</p>
          <div className="mt-4 text-xs text-gray-500">
            <span className="inline-block px-2 py-1 border border-cyber-blue rounded">
              状态: <span className="animate-cyber-pulse">在线</span>
            </span>
          </div>
        </div>

        <div className="cyber-border rounded-lg p-6 bg-dark-surface">
          <h2 className="text-2xl font-bold text-cyber-blue mb-6 text-center">
            {isRegister ? '账号注册' : '账号登录'}
          </h2>
          
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">
                邮箱地址
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input-cyber w-full px-4 py-3 rounded text-cyber-blue placeholder-gray-500"
                placeholder="your@email.com"
                required
              />
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">
                密码
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input-cyber w-full px-4 py-3 rounded text-cyber-blue placeholder-gray-500"
                placeholder="•••••••"
                required
                minLength={6}
              />
            </div>
            
            <button
              type="submit"
              disabled={loading}
              className="cyber-button w-full py-3 rounded text-dark-bg font-bold text-lg disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? '处理中...' : (isRegister ? '创建账号' : '登录系统')}
            </button>
          </form>
          
          {message && (
            <div className={`mt-4 p-3 rounded text-center text-sm ${
              message.includes('成功') 
                ? 'bg-green-900 text-green-300 border border-green-700'
                : 'bg-red-900 text-red-300 border border-red-700'
            }`}>
              {message}
            </div>
          )}
          
          <div className="mt-6 text-center">
            <p className="text-gray-400 text-sm">
              {isRegister ? '已有账号？' : '还没有账号？'}
              <button
                type="button"
                onClick={() => {
                  setIsRegister(!isRegister);
                  setMessage('');
                }}
                className="text-cyber-blue hover:underline font-medium ml-2"
              >
                {isRegister ? '立即登录' : '立即注册'}
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
